import i18next from 'i18next';

// Import services
import services from 'services/services';

// Import action types
import * as types from 'store/actions/types';

// Import helpers
import { checkErrorStatus } from 'store/helpers/error_status';
import { openNotification } from 'components/utilities/notification/notification';

// ******************** FETCH RELATED PROVIDERS ********************
export const fetchRelatedProviders = () => async (dispatch) => {
	try {
		// Dispatch loading action
		dispatch({
			type: types.FETCH_RELATED_PROVIDERS_LOADING,
			payload: true
		});

		const { data } = await services.get('/subscriber/externalProvider/list');
		dispatch({
			type: types.FETCH_RELATED_PROVIDERS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_RELATED_PROVIDERS_ERROR
		});

		// Error notyfications
		checkErrorStatus(error) &&
			openNotification({
				type: 'error',
				title: i18next.t('user_profile_general_related_accounts_error_title'),
				description: i18next.t(
					'user_profile_general_related_accounts_fetch_error_msg'
				)
			});
	}
};

// ******************** DELETE RELATED PROVIDER ********************
export const removeRelatedProvider = (id) => async (dispatch) => {
	try {
		dispatch({
			type: types.REMOVE_PROVIDER_LOADING
		});

		const url = `/subscriber/externalProvider/${id}`;
		await services.delete(url);

		dispatch({
			type: types.REMOVE_PROVIDER_SUCCESS
		});

		// Update Related Providers
		await fetchRelatedProviders()(dispatch);
	} catch (error) {
		dispatch({
			type: types.REMOVE_PROVIDER_ERROR
		});

		// Error notifications
		checkErrorStatus(error) &&
			openNotification({
				type: 'error',
				title: i18next.t('user_profile_general_related_accounts_error_title'),
				description: i18next.t(
					'user_profile_general_related_accounts_remove_error_msg'
				)
			});
	}
};
